<router-outlet *ngIf="!isIframe">
</router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true">
  <mc-loading-indicator label="" fit="large" appearance="primary"></mc-loading-indicator>
  <p style="color: white"> Loading Data... </p>
</ngx-spinner>